import { render, staticRenderFns } from "./Updates.vue?vue&type=template&id=63ee18b8&scoped=true&"
import script from "./Updates.vue?vue&type=script&lang=ts&"
export * from "./Updates.vue?vue&type=script&lang=ts&"
import style0 from "./Updates.vue?vue&type=style&index=0&id=63ee18b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63ee18b8",
  null
  
)

export default component.exports